import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=9c508052&"
import script from "./IconSet.vue?vue&type=script&lang=js&"
export * from "./IconSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports